import React, { Component } from 'react';
import {
  Button,
  Table,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  FormGroup,
  TextArea,
  TableToolbar,
  DataTableSkeleton,
  RadioButtonGroup,
  RadioButton, //RITM1102953
  TextInput, //RITM1359058
} from 'carbon-components-react';
import { Link } from 'react-router-dom';
import { ArrowRight16, Checkmark24 } from '@carbon/icons-react';
import { Section } from '../../lib/react-scroll-section/src/index';
import { Menu, Item } from '../../helpers/scrolling/ScrollingMenuItem';
import '../../scss/custom.scss';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getSuccess, getError, entitiesLabels, apioperation } from '../../helpers/Constants';
import { api } from '../../helpers/api/api';
import SimpleReactValidator from 'simple-react-validator';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { IsEditable } from '../../helpers/authorization/Policies';
import { StatusTag } from '../../helpers/PageBreadCrumb';
import AttachmentTable, { attachmentTablePrivacyText } from "../common/AttachmentTable"; //RITM1405215
import { v4 as uuid } from 'uuid'; //RITM1405215
const IncidentTabCausesModel = {
  id: null,
  investigationCriticalFactors: null, 
  returnOfExperience: null,
  incidentCAR: [],
   noREXReported: null, //RITM1102953
    rexCode: null,//RITM1359058
    timelineEventDescription: null, //RITM1405215
};

export default class IncidentTabCauses extends Component {
  initialState = (props) => {
    let initialState = {
      incidentModel: {
        ...IncidentTabCausesModel,
      },
      isDisabled: true,
    };
    if (props.incidentEditModel) {
      initialState.incidentModel = { ...props.incidentEditModel };
      initialState.isDisabled = !IsEditable(
        'Incident',
        'Reporting',
        props.user,
        props.incidentEditModel.status.id,
        'Causes',
        props.incidentEditModel
      );
    }
    return initialState;
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.updateState = this.updateState.bind(this);

    this.state = {
      ...this.initialState(props),
      PELFinalValue: null, //RITM1405215
      PHLFinalValue: null, //RITM1405215

    };
  }

  //RITM1405215
  componentDidMount() {
    this.getIncidentHighConsequenceLevel();
  }
  //End

  //RITM1420951
  componentDidUpdate(prevProps) {
    if ((JSON.stringify(prevProps.outcomeModel?.find(out => out.idOutcome == 0)?.idHighConsequenceLevelPotentialFinal) !==
        JSON.stringify(this.props.outcomeModel?.find(out => out.idOutcome == 0)?.idHighConsequenceLevelPotentialFinal))
        || (JSON.stringify(prevProps.outcomeModel?.find(out => out.idOutcome == 2)?.idHighConsequenceLevelPotentialFinal) !==
        JSON.stringify(this.props.outcomeModel?.find(out => out.idOutcome == 2)?.idHighConsequenceLevelPotentialFinal))
    ) {
      console.log("Old:", prevProps.outcomeModel);
      console.log("New:", this.props.outcomeModel);
      this.getIncidentHighConsequenceLevel();
    }
  }
  //End

  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;
    //RITM1359058
    if (inputName == 'noREXReported' && !inputValue) {
      statusCopy[objName]['rexCode'] = null;
    }
    //End
    this.setState(statusCopy);
  };

  selectTab = (index) => {
    this.props.selectTab(index);
  };

  saveTabCauses = () => {
    if (this.validator.allValid()) {
      this.props.isSubmitted(true);

      let datiForm = this.state.incidentModel;

      api
        .put('/incident/', datiForm, datiForm.id + '/causes')
        .then((response) => {
          if (response.status === 200) {
            showNotification.success(
              `${entitiesLabels.SUCCESS}`,
              this.state.incidentModel.id != null
                ? `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${
                    datiForm.incidentReportId
                  } ${getSuccess('causes', apioperation.PUT)}`
                : getSuccess(entitiesLabels.INCIDENT, apioperation.POST)
            );
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.INCIDENT, apioperation.POST)
          );
        })
        .finally(() => {
          this.props.isSubmitted(false);
        });
      this.props.updateCacheIncidentModel(datiForm, 'tabCauses');
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        entitiesLabels.INCIDENT + ' required fields are missing  '
      );
      this.forceUpdate();
    }
  };

  //RITM1102953
  handleChangeRadio = (value, id, event) => {
    console.log(event.target)
    if (value == 'true') {
      value = true;
    } else if (value == 'false') {
      value = false;
    } else if (value == 'null') {
      value = null;
    }

    this.updateState(event.target.name, value, event.target.alt);
  };
  //End

  //RITM1405215
  clearAttachment = () => ({
		id: null, // guid
		fileIdentifier: null,
		name: null,
		contentType: null,
		size: null,
		type: null,
	});

  onUploadFiles = (fileIdentifier, fileName, fileType, size, documentType) => { 
		const attachment = { ...this.state.attachment };

		attachment.id = uuid();
		attachment.fileIdentifier = fileIdentifier.blobName;
		attachment.name = fileName;
		attachment.contentType = fileType;
		attachment.size = size;
		// attachment.filePath = file.localPath;

		this.setState({
			attachment: this.clearAttachment(),
		});

		try {
			if (attachment == null) return;
			// insert
			const oldattachment = this.state.incidentModel.attachments || [];

			const newItem = {
        id: uuid(), // guid RITM1405215
				idAttachment: attachment.id, // guid
        documentType: documentType,
				attachment,
			};

			const newattachment = oldattachment.concat([newItem]);
			this.setState({ incidentModel: { ...this.state.incidentModel, attachments: newattachment } })
		} catch (error) {
			showNotification.error();
		}
	};

	onRemoveFile = (id) => {
		if (!id) return;
		const statusCopy = { ...this.state.incidentModel };
		statusCopy.attachments = statusCopy.attachments.filter((el) => el.id !== id);    
		this.setState({ incidentModel: statusCopy });
	};

  getIncidentHighConsequenceLevel = async () => {
    const outcomeharm =this.props.outcomeModel?.find(out => out.idOutcome ==0);
    const outcomeEnv =this.props.outcomeModel?.find(out => out.idOutcome ==2);
    this.setState({
        PELFinalValue : outcomeEnv != null ? (this.props.appHighConsequenceLevels.find((el) => el.id == outcomeEnv.idHighConsequenceLevelPotentialFinal)?.ranking) : null,
        PHLFinalValue : outcomeharm != null ? (this.props.appHighConsequenceLevels.find((el) => el.id == outcomeharm.idHighConsequenceLevelPotentialFinal)?.ranking) : null,
    });
  }
  //End

  //RITM1519246
  getphcfLevel = (phlFinalValue, pelFinalValue) => {
    if (phlFinalValue == null && pelFinalValue == null) return null;
    const phcf = (phlFinalValue == null && pelFinalValue != null) ? parseInt(pelFinalValue) : ((phlFinalValue != null && pelFinalValue == null) ? parseInt(phlFinalValue) : Math.max(parseInt(phlFinalValue), parseInt(pelFinalValue)));
    return !Number.isNaN(phcf) ? phcf : null;
  };
  //End

  render() {
    const validations = {
      investigationCriticalFactors: this.validator.message(
        'investigationCriticalFactors',
        !((this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) 
          || (this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null 
            && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) > 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) < 4 && this.props.workRelated === 'Commuting')) || this.props.isConsolidationActionNo == true 
        ? this.state.incidentModel.investigationCriticalFactors : true, //RITM1405215 RITM1519246 RITM1420951
        'required'
      ),
      noREXReported: this.validator.message( //RITM1102953
        'noREXReported',
        this.state.incidentModel.noREXReported,
        'required'
      ),
    };
    if (!this.props.incidentEditModel || !this.props.incidentEditModel.id) {
      return null;
    }

    const rows = this.state.incidentModel.incidentCAR || [];

    return (
      <>
        <div className="bx--row">
          <div className="padding-progress-indicator-vertical hidden-box">
            <Menu>
              <Item section="investfind">3.1 Investigation Findings</Item>
              <Item section="carsection">3.2 ROOT CAUSES ANALISYS</Item>
            </Menu>
          </div>
          <div className="bx--col-lg-10 bx--col-md-10 margin-progress-indicator-vertical">
            <Section id="investfind" className="section--title">
              <div>
                {/* RITM1405215 RITM1519246 RITM1420951*/}
                <h3 className="title--medium--expressive">{"3.1 Investigation Findings" + (!((this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) 
                  || (this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null 
                    && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) > 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) < 4 && this.props.workRelated === 'Commuting'))|| this.props.isConsolidationActionNo == true 
                          ? "(*)" : "")}</h3>
                <h6>(It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))</h6>
              </div>

              <div className="bx--row row-content section--title">
                <div className="bx--col-lg-12 bx--col-md-12">
                  {/* RITM1405215 RITM1519246 RITM1420951 */}
                  <FormGroup legendText={"Direct Cause (Casual factor) and Findings Description" + (!((this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) 
                    || this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null 
                      && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) > 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) < 4 && this.props.workRelated === 'Commuting') || this.props.isConsolidationActionNo == true 
                            ? "*" : "")}>
                    <TextArea
                      //RITM1109541 - Incident Investigation Causes Critical Factors Length Increase
                      maxLength={20000}
                      id="investigationCriticalFactors"
                      placeholder="Input detailed description"
                      value={this.state.incidentModel.investigationCriticalFactors || ''}
                      onChange={(el) =>
                        this.updateState(
                          'investigationCriticalFactors',
                          el.target.value,
                          'incidentModel'
                        )
                      }
                      hideLabel={true}
                      labelText=""
                      light
                      rows={4}
                      cols={100}
                      invalid={validations.investigationCriticalFactors != null}
                      disabled={this.state.isDisabled}
                    />
                    {validations.investigationCriticalFactors}
                  </FormGroup>
                </div>
                <div className="bx--col-lg-12 bx--col-md-12 mb-20px">
										<div>
											<h3 className="title--medium--expressive">Direct Cause (Causal Factor) and Findings</h3>
										</div>								
                    <AttachmentTable
                        storagePath="incident"
                        model={this.state.incidentModel}
                        items={this.state.incidentModel?.attachments?.filter(s => s.documentType == 'DirectCauseFinding') || []}
                        apiDownloadUrl={`/incident/${this.state.incidentModel.id}/attachment/`}
                        onUploadFIle={this.onUploadFiles}
                        onDeleteFile={this.onRemoveFile}
                        maxUploadDocument={1}
                        customMainDescription={"Upload only one file at 3 Mb or less; please check the file attached before to submit the report because afterwards it is not possible to modify it"}
                        isDisabled={this.state.isDisabled}
                        documentType={"DirectCauseFinding"}
                    />
                </div>
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Timeline of Events Description">
                    <TextArea
                      maxLength={20000}
                      id="timelineEventDescription"
                      placeholder="Input timeline of events description"
                      value={this.state.incidentModel.timelineEventDescription || ''}
                      onChange={(el) =>
                        this.updateState(
                          'timelineEventDescription',
                          el.target.value,
                          'incidentModel'
                        )
                      }
                      hideLabel={true}
                      labelText=""
                      light
                      rows={4}
                      cols={100}
                      disabled={this.state.isDisabled}
                    />
                  </FormGroup>
                </div>
                <div className="bx--col-lg-12 bx--col-md-12 mb-20px">
										<div>
											<h3 className="title--medium--expressive">Timeline of Events chart</h3>
										</div>								
                    <AttachmentTable
                        storagePath="incident"
                        model={this.state.incidentModel}
                        items={this.state.incidentModel?.attachments?.filter(s => s.documentType == 'EventChart') || []}
                        apiDownloadUrl={`/incident/${this.state.incidentModel.id}/attachment/`}
                        onUploadFIle={this.onUploadFiles}
                        onDeleteFile={this.onRemoveFile}
                        maxUploadDocument={1}
                        customMainDescription={"Upload only one file at 3 Mb or less; please check the file attached before to submit the report because afterwards it is not possible to modify it"}
                        isDisabled={this.state.isDisabled}
                        documentType={"EventChart"}
                    />
                </div>
                {/* End */}
                {/* RITM1359058 */}
                <div className="bx--row" style={{width:"100%", display:"flex", justifyContent:"flex-end", marginBottom:"50px"}}>
                  <div className={this.state.incidentModel.noREXReported === true ? "bx--col-lg-2 bx--col-md-2" : "bx--col-lg-12 bx--col-md-8"} > 
                    {/* RITM1102953 */}
                    {/* <FormGroup legendText="REX (Return of Experience) proposal (​

  It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))" >
                      <TextArea
                        maxLength={5000}
                        id="returnOfExperience"
                        placeholder="Input REX (Return of Experience) proposal"
                        value={this.state.incidentModel.returnOfExperience || ''}
                        onChange={(el) =>
                            this.updateState('returnOfExperience', el.target.value, 'incidentModel')
                        }
                        hideLabel={true}
                        labelText=""
                        light
                        rows={4}
                        cols={100}
                        disabled={this.state.isDisabled}
                      />
                    </FormGroup> */}
                    {/* RITM1310338 */}
                    <FormGroup legendText="Is there any REX (Return of Experience) to be reported?*" >
                        <RadioButtonGroup
                          labelPosition="right"
                          legend=""
                          name="noREXReported"
                          onChange={this.handleChangeRadio}
                          orientation="horizontal"
                          valueSelected={
                            this.state.incidentModel.noREXReported != null
                              ? this.state.incidentModel.noREXReported.toString()
                              : ''
                          }
                        >
                          <RadioButton
                            id="noREXReportedYes"
                            value="true"
                            labelText="Yes"
                            alt="incidentModel"
                            disabled={this.state.isDisabled}
                          />
                          <RadioButton
                            id="noREXReportedNo"
                            value="false"
                            labelText="No"
                            alt="incidentModel"
                            disabled={this.state.isDisabled}
                          />
                        </RadioButtonGroup>
                        {validations.noREXReported}
                    </FormGroup>
                    </div>
                  {/* End */}
                  {/* RITM1359058 */}
                  { this.state.incidentModel.noREXReported === true ?           
                    (          
                      <div className="bx--col-lg-10 bx--col-md-6">   
                        <FormGroup legendText="Insert here the REX code: Please enter the &quot;Insight Incident Code&quot; into the REFLEX field &quot;External Reference Source&quot; during the creation of REX" >
                            <TextInput
                                  //RITM1359058
                                  id="rexCode"
                                  name="rexCode"
                                  placeholder="Input REX code"
                                  value={ this.state.incidentModel.rexCode || ''}
                                  onChange={(el) =>
                                    this.updateState(
                                      'rexCode',
                                      el.target.value,
                                      'incidentModel'
                                    )
                                  }
                                  hideLabel={true}
                                  labelText=""
                                  type="text"
                                  disabled={this.state.isDisabled}
                                /> 
                           </FormGroup>
                           </div>
                      )  : (
                          ""
                    )
                  }
                  {/* End */}
                </div>
                {/* End */}
              </div>
            </Section>

            <Section id="carsection">
              <div>
                <h3 className="title--medium--expressive">3.2 ROOT CAUSES ANALISYS</h3>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-12 table-section-action">
                  <TableToolbar>
                    <h3 className="title--medium max-width"></h3>
                    <Link to={'/incident/' + this.props.incidentEditModel.id + '/car'}>
                      <Button 
                      renderIcon={ArrowRight16} 
                      className="table-toolbar-link-button" 
                      onClick={() => this.saveTabCauses()}
                      >
                        CAR Management
                      </Button>
                    </Link>
                  </TableToolbar>

                  <TableContainer className="bx--grid--full-width">
                    {this.props.isLoadingIncident ? (
                      <DataTableSkeleton headers={[]} rowCount={3} zebra={false} compact={false} />
                    ) : (
                      <Table>
                        <TableHead className="colorgray">
                          <TableRow>
                            <TableHeader>Owner Name</TableHeader>
                            <TableHeader>Owner Surname</TableHeader>
                            <TableHeader>CAR Code</TableHeader>
                            <TableHeader>Due Date</TableHeader>
                            <TableHeader className={'align-center'}>CAR Owner Involved</TableHeader>
                            <TableHeader>Status</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length === 0 ? (
                            <NoRecordsPlaceholder labelText="No Records" colSpan={5} />
                          ) : (
                            rows.map((item, index) => (
                              <TableRow key={'row_' + item.id}>
                                <TableCell key={'cell_name_' + item.id}>
                                  {item.owner != null
                                    ? item.owner.name
                                    : item.ownerSaipem != null
                                    ? item.ownerSaipem.name
                                    : ''}
                                </TableCell>
                                <TableCell key={'cell_surname_' + item.id}>
                                  {item.owner != null
                                    ? item.owner.surname
                                    : item.ownerSaipem != null
                                    ? item.ownerSaipem.surname
                                    : ''}
                                </TableCell>
                                <TableCell key={'cell_carCode_' + item.id}>
                                  {item.incidentCARCode}
                                </TableCell>
                                <TableCell key={'cell_dueDate_' + item.id}>
                                  {' '}
                                  {switchDateFormat(item.dueDate, 'date')}
                                </TableCell>
                                <TableCell
                                  key={'cell_carOwnerInvolved_' + item.id}
                                  className={' align-center'}
                                >
                                  {this.state.incidentModel.idStatus > 2 ? (
                                    <Checkmark24 fill="#1A3E4C" aria-label="" />
                                  ) : (
                                    ''
                                  )}
                                </TableCell>
                                <TableCell key={'cell_status_' + item.id}>
                                  <StatusTag value={item.status && item.status.carManagementName} />
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                </div>
              </div>
            </Section>
          </div>
        </div>
        <div className="bx--row">
          <Button
            onClick={() => this.selectTab(1)}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Prev Step
          </Button>
          <Button
            onClick={() => this.props.cancel()}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => this.saveTabCauses()}
            disabled={this.state.isDisabled}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="primary"
          >
            Save
          </Button>
          <Button
            onClick={() => window.print()}
            disabled={this.state.isDisabled}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Print
          </Button>
          <Button
            onClick={() => this.selectTab(3)}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Next Step
          </Button>
        </div>
      </>
    );
  }
}
